module.exports = __webpack_public_path__ + "static/Set-Variant-MT-caaf8600e988a3e1947de92f01778809.png";